import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@app/modules/shared/services/auth.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";

@Component({
  selector: "kl-new-password",
  templateUrl: "./new-password.component.html",
  styleUrls: ["./new-password.component.scss"],
})
export class NewPasswordComponent implements OnInit, AfterViewInit {
  errorStatus = false;
  showError: boolean;
  successStatus = false;
  passwordStatus = false;
  selectedLanguage: string;
  token: any;
  new = {
    password: "",
    confirm_password: "",
  };

  constructor(
    private _translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private klLoadingService: KlLoadingService,
    private alertService: KlSweetAlertService,
    private activeRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    if (localStorage.getItem("currentLanguage")) {
      this.selectedLanguage = localStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    this.selectLang(this.selectedLanguage);
    this.token = this.activeRoute.snapshot.queryParams.token;
  }

  ngAfterViewInit() {
    if (!this.token) {
      setTimeout(() => {
        this.router.navigateByUrl("/auth/login");
      }, 5000);
    }
  }

  selectLang(lang: string) {
    this._translate.useCulture(lang);
    this._translate.use(lang);
  }

  changeErrorStatus() {
    this.errorStatus = false;
    this.passwordStatus = false;
  }

  onSubmit() {
    if (this.new.password === this.new.confirm_password) {
      this.klLoadingService.show("loading");
      const payload = {
        new_password: this.new.password,
      };
      this.authService.setPassword("activate/" + this.token, payload).subscribe(
        (resNew) => this.handleResponse(resNew),
        (errNew) => this.handleError(errNew)
      );
    } else {
      this.passwordStatus = true;
    }
  }

  handleResponse(response) {
    this.klLoadingService.hide();
    this.successStatus = true;
    this.errorStatus = false;
  }

  handleError(error) {
    this.klLoadingService.hide();
  }
}
